App.directive('autogrow', function() {
  return function(scope, element, attr, ngModel){
      var update = function(){
          element.css("height", "auto");
          element.css("height", element[0].scrollHeight + "px");
      };
      scope.$watch(() => element.val(), function(){
          update();
      });
      scope.$watch(() => element[0].scrollHeight, function(){
          update();
      });
      attr.$set("ngTrim", "false");
  };
});
